<script>
import CategoryProducts from './CategoryProducts'

/**
 * Budget planning section: the shop category picker of the product category section picks
 * which categories (with their subcategories) the planning shows. Tags mean nothing here.
 */
export default {
    name: 'BudgetPlanning',
    extends: CategoryProducts,
    computed: {
        tagsEditable() {
            return false;
        },
    },
};
</script>
